import * as React from 'react';
export const hsbcSvg = React.forwardRef(function hsbcSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E0202E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M22.07 22.49V9.5l5.6 6.3-5.6 6.68zm0 0H9.93L15.64 16 9.93 9.51h12.14L16 16l6.07 6.49zM4.32 15.8l5.6-6.29V22.5l-5.6-6.69z',
      }),
    ),
  );
});
hsbcSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var hsbc = {
  category: 'brand',
  colorable: false,
  name: 'hsbc',
  svg: hsbcSvg,
};
